<!--
 * Description  :
 * Date         :2021-11-01 14:02:38
 * LastEditors  :chenjia
 * LastEditTime :2021-12-23 09:49:01
 * FilePath     :\abackup-pay\src\App.vue
-->
<template>
  <div id="app">
    <ab-header></ab-header>
    <div class="g-bx">
      <div class="g-cnt">
        <router-view />
      </div>
    </div>
    <ab-footer></ab-footer>
  </div>
</template>

<style lang="less">
@import "./assets/main-pay.less";
</style>

<script>
import AbHeader from "@/components/HeaderFooter/Header.vue";
import AbFooter from "@/components/HeaderFooter/Footer.vue";
export default {
  name: "app",
  components: {
    AbHeader,
    AbFooter,
  },
};
</script>
